import * as React from "react";
import { SVGProps } from "react";

const OxxoSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={50}
    height={14}
    viewBox="25 21 54 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <path d="M78.81,21.32v.76H25.19v-.76c0-.92.75-1.67,1.67-1.67h50.28c.92,0,1.67.75,1.67,1.67Z" />
      <path d="M25.19,41.92h53.62v.76c0-.92-.75,1.67-1.67,1.67H26.86c-.91,0-1.67-.75-1.67-1.67v-.76Z" />
      <g opacity={0.92}>
        <path d="M70.63,27.23c-2.45,0-4.45,2-4.45,4.45s2,4.45,4.45,4.45,4.45-2,4.45-4.45-2-4.45-4.45-4.45ZM33.93,27.23c-2.45,0-4.45,2-4.45,4.45s2,4.45,4.45,4.45,4.45-2,4.45-4.45-2-4.45-4.45-4.45h0Z" />
        <path d="M70.28,23.31c-4.12-.09-6.06,2.55-8.87,5.81l-2.65,3.07,4.2,5.03c1,1.55-.91,3.08-2.09,1.67l-3.88-4.63-3.78,4.39c-1.21,1.4-3.09-.16-2.07-1.69l4.11-4.78-2.69-3.21,1.73-2.14,2.74,3.29,2.36-2.75c1.16-1.35,2.34-3.13,3.87-4.05H25.19v17.38h8.9c4.12,0,5.99-2.47,8.73-5.79l2.58-3.14-4.32-4.93c-1.04-1.52.84-3.1,2.06-1.71l3.99,4.54,3.68-4.47c1.17-1.42,3.1.09,2.11,1.65l-4,4.87,2.77,3.15-1.74,2.06-2.75-3.1-2.3,2.8c-1.13,1.37-2.27,3.12-3.78,4.07h37.69v-17.38h-8.53ZM40.97,31.68c0,3.87-3.16,7.03-7.03,7.03s-7.04-3.16-7.04-7.03,3.16-7.04,7.04-7.04,7.03,3.16,7.03,7.04h0ZM70.63,38.72c-3.87,0-7.04-3.16-7.04-7.03s3.16-7.04,7.04-7.04,7.03,3.16,7.03,7.04-3.16,7.03-7.03,7.03h0Z" />
      </g>
    </g>
  </svg>
);

export default OxxoSimple;
